import { render, staticRenderFns } from "./dialog-addgroup.vue?vue&type=template&id=b23ec5ba&"
import script from "./dialog-addgroup.vue?vue&type=script&lang=js&"
export * from "./dialog-addgroup.vue?vue&type=script&lang=js&"
import style0 from "./dialog-addgroup.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports